import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import CheckIcon from "../icons/CheckIcon.vue";
import ErrorIcon from "../icons/ErrorIcon.vue";

interface Props {
	variant: 'valid' | 'empty' | 'error';
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AccordionIndicator',
  props: {
    variant: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['accordion-indicator', `accordion-indicator--${_ctx.variant}`])
  }, [
    (_ctx.variant === 'valid')
      ? (_openBlock(), _createBlock(CheckIcon, {
          key: 0,
          "aria-hidden": "true"
        }))
      : _createCommentVNode("", true),
    (_ctx.variant === 'error')
      ? (_openBlock(), _createBlock(ErrorIcon, {
          key: 1,
          "aria-hidden": "true"
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})